module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "home.10b79cc8.jpeg" + "?" + Date.now();